export default IconBrandSuperhuman => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-brand-superhuman" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M16 12l4 3l-8 7l-8 -7l4 -3" />
  <path d="M12 3l-8 6l8 6l8 -6z" />
  <path d="M12 15h8" />
</svg>`;